export default {
    create_company: 'Choose your subdomain',
    invoice_info: 'Invoices are sent on the first of each month for the previous month',
    congratulations: 'Congratulations!',
    became_a_partner: 'You have become a Bookeraj partner',
    partner_info_one:
        'It is important to know that you can unsubscribe or change your plan at any time. Changes to the plan will take effect from the 1st of the following month',
    partner_info_two: 'If you need assistance, feel free to contact us on our contact page or through social media.',
    go_to_your_company: 'Go to your company',
    enter_subdomain: 'Enter your subdomain',
    subdomain: 'Subdomain',
    subdomain_footnote: 'By entering a subdomain, your site will be active under it.',
    choose_theme: 'Choose a theme',
    view: 'View',
    enter_company_details: 'Enter company details',

    progressbar: {
        create_step: 'Company data',
        package_step: 'Package selection',
        finish_step: 'Final step',
    },

    package_step: {
        title: 'Choose your package',
        description: 'Start the first month for free. No credit card required.',
        monthly: 'Monthly',
        yearly: 'Annual',
        button: 'START FREE',
        basic: {
            title: 'Basic',
            option1: 'First month free',
            option2: 'Unlimited services',
            option3: 'Unlimited reservations',
            option4: 'Unlimited employees',
            option5: 'Unlimited locations',
            option6: 'Inactivity settings',
            option7: 'Profile configuration',
            option8: 'Client base and the ability to block users',
        },
        pro: {
            title: 'Professional',
            option1: 'First month free',
            option2: 'Unlimited services',
            option3: 'Unlimited reservations',
            option4: 'Unlimited employees',
            option5: 'Unlimited locations',
            option6: 'Inactivity settings',
            option7: 'Profile configuration',
            option8: 'Separate reservation website exclusively for your company',
            option9: 'Configuration of your website (theme selection, images, description)',
            option10: 'Subdomain with your website',
            option11: 'Sticker with QR code',
            option12: 'Client base and the ability to block users',
        },
        invoice_info: 'Invoices are sent on the first of each month for the previous month',
    },
}
